import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useSlideInfoForPathologyMapStyles } from 'components/PathologyMap/constants/styles';
import { useOrdersTabContentStyles } from 'components/UserProfile/styles';
import { CommentInfo } from 'components/UserProfile/LatestCommentsCard/CommentInfo';
import { Spinner } from 'components/Loading/Spinner/Spinner';

export const LatestCommentsCard = ({ newsFeed, onLoadMore, isLoadingMore }) => {
  const { classes: classesFromPathologyMap } =
    useSlideInfoForPathologyMapStyles();
  const { classes: orderTabStyles } = useOrdersTabContentStyles();
  const classes = { ...classesFromPathologyMap, ...orderTabStyles };

  const comments = newsFeed?.slide_comments || [];
  const totalComments = newsFeed?.slide_comments_count ?? comments.length;
  const hasMoreComments = comments.length < totalComments;

  const renderComments = () => (
    <>
      {comments.length ? (
        comments.map((comment) => (
          <CommentInfo key={comment.uuid} comment={comment} classes={classes} />
        ))
      ) : (
        <Typography marginY="auto">No comments</Typography>
      )}
      {hasMoreComments && (
        <Box display="flex" justifyContent="center" paddingTop="0.75rem">
          <Button onClick={onLoadMore} disabled={isLoadingMore}>
            {isLoadingMore ? 'Loading…' : 'Load more'}
          </Button>
        </Box>
      )}
    </>
  );

  if (newsFeed) return renderComments();

  return (
    <Box className={classes.spinnerContainer}>
      <Spinner />
    </Box>
  );
};
